import { GlobalState } from "@app/store";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const role = useSelector((state: GlobalState) => state.auth.role);

  return role ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
